class Paths {
  constructor() {
    this.dashboard = '/dashboard';

    /* user profile path */

    this.profile = {
      home: `/profile`,
    };
    this.profile.info = `${this.profile.home}/info`;
    this.profile.contacts = `${this.profile.home}/contacts`;
    this.profile.addresses = `${this.profile.home}/addresses`;
    this.profile.docs = `${this.profile.home}/docs`;

    /* client accounts paths */

    this.client = {
      accounts: {
        index: '/accounts',
      },
    };
    this.client.accounts.create = `${this.client.accounts.index}/create`;

    /* admin users path */

    this.users = {
      home: `${this.dashboard}/users`,
    };
    this.users.create = `${this.users.home}/create`;
  }
}

export const paths = new Paths();
